import React from 'react';
import './SkeletonHeader.css';
import {Skeleton} from 'antd';

export function SkeletonNavigation() {
    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#fff', gap: 24, padding: 8 }}>
        {/* Barra vertical izquierda */}
        <div style={{ width: 24, display: 'flex', flexDirection: 'column', marginRight: 16}}>
          <Skeleton.Button active style={{ width: 24, height: '100vh', borderRadius: 8, marginRight: 24}} />
        </div>
        {/* Contenido principal */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', marginLeft: 16}}>
          {/* Barra horizontal superior */}
          <Skeleton.Button active style={{ width: '99%', height: 750, borderRadius: 8, marginTop: 24, marginBottom:24, paddingRight: 24   }} block />
        </div>
      </div>
    )
}
